import { SupportedFitnessApp } from '../../../../core/api/FitnessActivityClient';

const greenShades = ['#22c55e', '#16a34a', '#15803d', '#166534', '#14532d'];
const orangeShades = ['#f97316', '#ea580c', '#c2410c', '#9a3412', '#7c2d12'];

export const activityColorPalettes: Record<string, string[]> = {
    WALKING: greenShades,
    DAILY_STEPS: greenShades,
    RUNNING: orangeShades
};
export const activityLabels: Record<string, string> = {
    WALKING: 'Walking',
    DAILY_STEPS: 'Daily Steps',
    RUNNING: 'Running'
};

export const providerLabels: Record<SupportedFitnessApp, string> = {
    GOOGLE_FIT: 'Google Fit',
    APPLE_HEALTH: 'Apple Health',
    STRAVA: 'Strava',
    GARMIN: 'Garmin',
    FITBIT: 'Fitbit',
    POLAR: 'Polar',
    MYSPORTS_REWARDS: 'MySports Rewards',
    MOVE_REPUBLIC: 'Move Republic',
    MOVE_REPUBLIC_ADMIN: 'Move Republic Admin',
    HEALTH_CONNECT: 'Health Connect',
    WITHINGS: 'Withings',
    HUAWEI_HEALTH: 'Huawei',
    SAMSUNG_HEALTH: 'Samsung Health',
    SUUNTO: 'Suunto',
    ZEPP: 'Zepp',
    GOOGLE_HEALTH: 'Google Health'
};
